import { addDiscoveryPages, addDiscoveryMyBills, resetDiscoveryMyBills, deleteDiscoveryMyBills, addVisitedPageDiscovery } from "./actions";
import { uniq, isArray, compact } from "lodash";
import { createReducer } from "@reduxjs/toolkit";
import { DiscoveryStateType } from "./types";

const initialState: DiscoveryStateType | any = {
  pages: {},
  myBills: [],
  visitedPages: ["0"],
};

export const discoveryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(addDiscoveryPages, (state, action) => {
      state.pages = {
        ...state.pages,
        ...action.payload,
      };
    })
    .addCase(addVisitedPageDiscovery, (state, action) => {
      // let data;
      // if (isArray(action.payload)) {
      //   data = action.payload;
      // } else {
      //   data = [...state.visitedPages, action.payload];
      // }
      state.visitedPages = uniq(isArray(action.payload) ? action.payload : [...state.visitedPages, action.payload]);
    })
    .addCase(addDiscoveryMyBills, (state, action) => {
      let prevMyBills = state.myBills || [];
      state.myBills = uniq([...prevMyBills, action.payload]);
    })
    .addCase(resetDiscoveryMyBills, (state, action) => {
      state.myBills = action.payload;
    })
    .addCase(deleteDiscoveryMyBills, (state, action) => {
      state.myBills = [...state.myBills, ...state.myBills.filter((bill: any) => bill.id !== action.payload)];
    });
});
